import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { MatButton } from '@angular/material/button';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { MatIcon } from '@angular/material/icon';
import { TranslocoPipe } from '@jsverse/transloco';
import { TButtonColor, TButtonVariant, TButtonType, TIconMetaData } from '@dss-libs/shared/type/common-types';

@Component({
  selector: 'dss-libs-ui-button,[dss-libs-ui-button]',
  templateUrl: './button.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatButton, MatProgressSpinner, MatIcon, TranslocoPipe],
  host: {
    '[attr.btn-color]': 'color()',
    '[attr.btn-variant]': 'variant()',
    '[attr.aria-busy]': 'isProcessing()',
    '[attr.disabled]': 'isProcessing() || disabled() || null',
  },
})
export class ButtonComponent {
  readonly color = input<TButtonColor>('primary');
  readonly variant = input<TButtonVariant>('fill');
  readonly iconMetaData = input<TIconMetaData | null>(null);
  readonly isProcessing = input(false);
  readonly disabled = input(false);
  readonly label = input<string>('');
  readonly type = input<TButtonType>('button');
  readonly ariaLabel = input<string | undefined>();
  readonly appliedClasses = input<string>('');

  readonly clickOutput = output<void>();
}
